import type { Adventure } from '../../types'

// Age 4-5: Adding Balloons - Addition Party
export const addingBalloonsAdventure: Adventure = {
  id: 'adding-balloons',
  title: 'Balloon Party Addition',
  theme: 'addition',
  targetAge: '4',
  difficulty: 'easy',
  estimatedDuration: 6,
  segments: {
    intro: {
      id: 'intro',
      tillyLine: "Hey party friend! Today we are having a balloon party and we are going to ADD balloons together! Are you ready?",
      duration: 5
    },
    story1: {
      id: 'story-1',
      tillyLine: "Look! I have 3 red balloons! And here come 2 blue balloons floating in! How many balloons do we have altogether?",
      duration: 6,
      background: 'party-sky'
    },
    choice1: [
      {
        id: 'add-them',
        label: "Add them up!",
        tillyLine: "Let us add the balloons! 3 plus 2 equals how many?",
        nextState: 'quiz-1'
      }
    ],
    quiz1: {
      id: 'quiz-1',
      type: 'simple-addition',
      question: '3 + 2 = ?',
      tillyPrompt: 'What is 3 plus 2?',
      options: [
        { id: '4', label: '4', isCorrect: false },
        { id: '5', label: '5', isCorrect: true },
        { id: '6', label: '6', isCorrect: false }
      ],
      num1: 3,
      num2: 2
    } as any,
    story2: {
      id: 'story-2',
      tillyLine: "Pop-pop-poppin! That is right! 3 plus 2 equals 5! Now I see 4 green balloons and 1 yellow balloon joins them!",
      duration: 6,
      background: 'party-sky'
    },
    choice2: [
      {
        id: 'add-more',
        label: "Add more!",
        tillyLine: "How many balloons are there now? 4 plus 1 equals...?",
        nextState: 'quiz-2'
      }
    ],
    quiz2: {
      id: 'quiz-2',
      type: 'simple-addition',
      question: '4 + 1 = ?',
      tillyPrompt: 'What is 4 plus 1?',
      options: [
        { id: '4', label: '4', isCorrect: false },
        { id: '5', label: '5', isCorrect: true },
        { id: '6', label: '6', isCorrect: false }
      ],
      num1: 4,
      num2: 1
    } as any,
    challenge: {
      intro: {
        id: 'challenge-intro',
        tillyLine: "You are a balloon adding expert! Here comes the big party challenge! Ready?",
        duration: 5,
        background: 'party-sky'
      },
      quizzes: [
        {
          id: 'challenge-1',
          type: 'simple-addition',
          question: '2 + 3 = ?',
          tillyPrompt: 'What is 2 plus 3?',
          options: [
            { id: '4', label: '4', isCorrect: false },
            { id: '5', label: '5', isCorrect: true },
            { id: '6', label: '6', isCorrect: false }
          ],
          num1: 2,
          num2: 3
        } as any
      ]
    },
    reward: {
      tillyLine: "POP! That is the sound of success! You are a Balloon Party Adder! Here is your party badge!",
      badgeName: 'Balloon Party Adder',
      badgeIcon: '🎈',
      nextPreview: 'Next time, we will share cookies with friends!'
    }
  }
}

export const tillyBalloonCorrect = [
  "Pop-tastic! You got it!",
  "Balloon-illiant! That is right!",
  "Party perfect! Amazing!",
  "You are floating with the right answer!",
  "High in the sky correct!",
  "Colorful and correct! Woo hoo!",
  "Balloon-tacular counting!",
  "Up, up, and right! You did it!",
  "Floating with success! Great job!",
  "Party time! That is correct!"
]

export const tillyBalloonWrong = [
  "Almost! Try adding again!",
  "Not quite! Keep floating!",
  "Good try! Count the balloons!",
  "Close! Give it another pop!",
  "That is okay! Balloons are tricky!",
  "Keep trying! You will rise up!",
  "Almost! Balloons believe in you!",
  "Try once more! You can do it!",
  "Not there yet! Keep floating!",
  "Pop! Try a different number!"
]

export const tillyBalloonCelebration = [
  "🎈 POP! POP! You did it! 🎈",
  "Balloon party champion! 🌟",
  "Floating high with success! 🏆",
  "Best balloon adder ever! 🎊",
  "Party time for you! 🥇"
]
